import {
  RETRIEVE_REVIEWS,
  DELETE_REVIEW,
  RESTORE_REVIEW,
  UPDATE_REVIEW_STATUS,
  CREATE_REVIEW,
  UPDATE_REVIEW,
} from "./types";

import ReviewService from "../services/review.service";

export const retrieveReviews = (keyword = '', page = '', perPage = '', all = true, active = true) => async (dispatch) => {
  try {
    const res = await ReviewService.getAll(keyword, page, perPage, all, active);
    dispatch({
      type: RETRIEVE_REVIEWS,
      payload: res.data.listReviews,
    });
  } catch (err) {
    console.log(err);
  }
};

export const updateReviewStatus = (id, data) => async (dispatch) => {
  try {
    const res = await ReviewService.updateStatus(id, data);

    dispatch({
      type: UPDATE_REVIEW_STATUS,
      payload: res.data.listReviews,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const deleteReview = (id, data) => async (dispatch) => {
  try {
    const res = await ReviewService.deleteReview(id, data);

    dispatch({
      type: DELETE_REVIEW,
      payload: res.data.listReviews,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const restoreReview = (id, data) => async (dispatch) => {
  try {
    const res = await ReviewService.restore(id, data);

    dispatch({
      type: RESTORE_REVIEW,
      payload: res.data.listReviews,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const createReview = (data) => async (dispatch) => {
  try {
    const res = await ReviewService.create(data);

    dispatch({
      type: CREATE_REVIEW,
      payload: res.data.listReviews,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updateReview = (id, data) => async (dispatch) => {
  try {
    const res = await ReviewService.update(id, data);

    dispatch({
      type: UPDATE_REVIEW,
      payload: res.data.listReviews,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};